/* eslint-disable class-methods-use-this */
let permissions = {};
/**
 * Permission Helper Class
 */
export default class Permissions {
  constructor(perms) {
    permissions = perms || {};
  }

  //----------------------------------
  // Inquiry Permissions
  //----------------------------------
  get inquiryCanViewAll() {
    return permissions?.inquiry.view.all;
  }

  get inquiryCanViewAssigned() {
    return permissions?.inquiry.view.assigned;
  }

  get inquiryCanCreateStub() {
    return permissions?.inquiry.create.stub;
  }

  get inquiryCanCreateFull() {
    return permissions?.inquiry.create.full;
  }

  get inquiryCanEditAll() {
    return permissions?.inquiry.edit.all;
  }

  get inquiryCanEditAssigned() {
    return permissions?.inquiry.edit.assigned;
  }

  get inquiryCanFinalize() {
    return permissions?.inquiry.finalize;
  }

  get inquiryCanAnonymize() {
    return permissions?.inquiry.anonymize;
  }

  get inquiryCanArchive() {
    return permissions?.inquiry.archive;
  }

  get inquiryCanDelete() {
    return permissions?.inquiry.delete;
  }

  get inquiryCanReopen() {
    return permissions?.inquiry.reopen;
  }

  get inquiryCanAllocate() {
    return permissions?.inquiry.allocate;
  }

  get inquiryCanTransferToUser() {
    return permissions?.inquiry.transfer.user;
  }

  get inquiryCanTransferToBranch() {
    return permissions?.inquiry.transfer.branch;
  }

  get inquiryCanTransferFully() {
    return permissions?.inquiry.transfer.full;
  }

  //----------------------------------
  // Report Permissions
  //----------------------------------
  get reportCanDownload() {
    return permissions?.report.download;
  }

  //--------------------------------------
  // User Permissions
  //--------------------------------------
  get userCanCreate() {
    return permissions?.user.create;
  }

  get userCanEdit() {
    return permissions?.user.edit;
  }

  get userCanDelete() {
    return permissions?.user.delete;
  }

  get userCanLock() {
    return permissions?.user.lock;
  }

  userCanAssignRole(role) {
    const roles = permissions?.user.roles || [];
    return roles.includes(role);
  }

  //--------------------------------------
  // Branch Permissions
  //--------------------------------------
  get branchCanCreate() {
    return permissions?.branch.create;
  }

  get branchCanEdit() {
    return permissions?.branch.edit;
  }

  get branchCanDelete() {
    return permissions?.branch.delete;
  }
}
